import React, { FC } from 'react';
import SidebarButton from '../sidebar-button/sidebar-button';
import { SidebarBadgeProps } from '../sidebar-button/sidebar-badge';

interface SidebarExpandoTitleProps {
  label: string;
  isHighlighted: boolean;
  onClick: () => void;
  badge: SidebarBadgeProps;
}

const SidebarExpandoTitle: FC<SidebarExpandoTitleProps> = ({ label, isHighlighted, onClick, badge }) => (
  <SidebarButton label={label} isActive={isHighlighted} onClick={onClick} badge={badge} />
);

export default SidebarExpandoTitle;
